import i18n from "@/locales";

/** The three interface languages; anything else is English. */
export function interfaceLanguage(lang: string | undefined = i18n.language): "en" | "fr" | "es" {
  const two = (lang ?? "en").slice(0, 2).toLowerCase();
  return two === "fr" || two === "es" ? two : "en";
}

function isLiliaApi(url: string): boolean {
  try {
    const u = new URL(url, window.location.href);
    return u.origin === window.location.origin && u.pathname.startsWith("/api/");
  } catch {
    return false;
  }
}

/**
 * Every call to Lilia's API says which interface language is in use (`X-Lilia-Locale`), so the
 * account keeps it and its emails (welcome, sign-in, reset) arrive in that language. Installed once
 * at start-up, before anything calls the API; other origins are left alone.
 */
export function installApiLocaleHeader() {
  const w = window as Window & { __liliaLocaleFetch?: boolean };
  if (w.__liliaLocaleFetch) return;
  w.__liliaLocaleFetch = true;
  const original = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const url = typeof input === "string" ? input : input instanceof URL ? input.href : input.url;
    if (!isLiliaApi(url)) return original(input, init);
    const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
    if (!headers.has("X-Lilia-Locale")) headers.set("X-Lilia-Locale", interfaceLanguage());
    return original(input, { ...init, headers });
  };
}
